import styled from 'styled-components';

import { Address } from '@dreryk/address-common-api';

import { addressFormatter, Address as CommonAddress } from '@dreryk/react-common';

type ServiceProvidingLocationDataProps = {
   readonly name?: string | null;
   readonly address?: CommonAddress | Address | null;
};

export const StyledServiceProvidingLocationData = styled.div`
   display: flex;
   flex-direction: column;
   gap: 4px;
`;

StyledServiceProvidingLocationData.displayName = 'StyledServiceProvidingLocationData';

export const ServiceProvidingLocationData = (props: ServiceProvidingLocationDataProps): JSX.Element => {
   return (
      <StyledServiceProvidingLocationData>
         {props.name ? <strong>{props.name}</strong> : null}
         {props.address ? <div>{addressFormatter(props.address)}</div> : null}
      </StyledServiceProvidingLocationData>
   );
};
